module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-ctn"
  }, [_c('div', {
    staticClass: "background-shape",
    style: ({
      transform: "rotate3d(0,0,1," + this.transform.rotate + "deg) scale3d(" + this.transform.scale.x + ", " + this.transform.scale.y + ", 1) translate3d(" + this.transform.translate.x + ", " + this.transform.translate.y + ", 0)"
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d461ba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Background.vue
// module id = 425
// module chunks = 1